import React from "react";
import { List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import {
  Map as MapIcon,
  Work as WorkIcon,
  People as PeopleIcon,
  Brightness4 as Brightness4Icon,
} from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

import ATMOPlanLogo from "src/assets/images/atmo-plan-logo-filled.png";
import { usePermissions } from "src/hooks";
import { IsEnabled } from "./permissions";

export function NavigationDrawer() {
  const { t } = useTranslation();
  const { data: permissions } = usePermissions();

  return render();

  function render() {
    if (!permissions) return null;

    return (
      <NavigationDrawerStyles>
        <div className="logo-brand">
          <img src={ATMOPlanLogo} alt="logo ATMOPlan" height={60} />
        </div>

        <List className="navigation-list">
          <ListItem className="navigation-item" button component={NavLink} to="/cases">
            <ListItemIcon>
              <WorkIcon />
            </ListItemIcon>
            <ListItemText primary={t("label.cases")} />
          </ListItem>

          <ListItem button component={NavLink} to="/background-concentrations">
            <ListItemIcon>
              <MapIcon />
            </ListItemIcon>
            <ListItemText primary={t("label.backgroundConcentrations")} />
          </ListItem>

          <ListItem button component={NavLink} to="/custom-meteo">
            <ListItemIcon>
              <Brightness4Icon />
            </ListItemIcon>
            <ListItemText primary={t("label.meteo")} />
          </ListItem>

          <IsEnabled permission={permissions.users.userAdmin}>
            <ListItem button component={NavLink} to="/users">
              <ListItemIcon>
                <PeopleIcon />
              </ListItemIcon>
              <ListItemText primary={t("label.userManagement")} />
            </ListItem>
          </IsEnabled>
        </List>
      </NavigationDrawerStyles>
    );
  }
}

const NavigationDrawerStyles = styled("div")`
  width: ${({ theme }) => theme.navigationDrawer.width}px;

  // necessary for content to be below app bar
  .toolbar {
    ${(props) => ({ ...props.theme.mixins.toolbar })}
  }

  .logo-brand {
    display: flex;
    align-items: center;
    justify-content: flex-start;

    img {
      width: auto;
    }
  }

  .navigation-list {
    padding-top: 60px;
  }

  .MuiListItem-root {
    &.active {
      background-color: ${({ theme }) => theme.palette.grey[100]};

      .MuiTypography-body1 {
        font-weight: bold;
      }
    }
  }
`;
